<template>
  <div class="system-notification">
    <message
      v-for="message in messages"
      :key="`${message.title}${message.text}`"
      :title="showTitle ? message.title : null"
      :text="message.text"
      :severity="getSeverity(message.level)"
      class="system-notification__message"
    />
  </div>
</template>

<script>
import Message from '@/components/Message'
import { client } from '@/helpers/http'

export default {
  name: 'DotcomSystemNotifications',

  components: {
    Message,
  },

  props: {
    app: {
      type: String,
      required: true,
    },

    baseUrl: {
      type: String,
      required: true,
    },

    platform: {
      type: String,
      default: 'others',
    },

    showTitle: {
      type: Boolean,
      default: false,
    },

    fetchMessages: {
      type: Function,
      default: async payload => {
        const result = await client().get(
          `${payload.serviceUri}?platform=${payload.platform}`,
        )
        return result.data
      },
    },
  },

  data() {
    return {
      messages: [],
      language: 'de',
    }
  },

  computed: {
    serviceUri() {
      return `${this.baseUrl}bin/sanitas-system-notification.${this.language}.${this.app}.json`
    },
  },

  mounted() {
    this.language = window.Sanitas.language || 'de'
    this.call()
  },

  methods: {
    async call() {
      const payload = {
        serviceUri: this.serviceUri,
        platform: this.platform,
      }
      const response = await this.fetchMessages(payload)
      if (response && response.notifications) {
        this.messages = response && response.notifications
      }
    },

    getSeverity(level) {
      switch (level) {
        default:
        case 'INFORMATION':
          return 'info'

        case 'ERROR':
          return 'error'

        case 'WARNING':
          return 'warning'

        case 'SUCCESS':
          return 'success'
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.system-notification {
  margin-top: var(--spacing-4);

  &__message {
    margin-bottom: var(--spacing-4);

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
